import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import {ImageResize} from "../../../../class/image-resize";
import { driver } from "driver.js";
declare var $: any;

@Component({
  selector: 'vex-exercise-detail',
  templateUrl: './exercise-detail.component.html',
  styleUrls: ['./exercise-detail.component.scss']
})
export class ExerciseDetailComponent implements OnInit {
  @Input() exercise: any;
  @Input() equips: any;
  @Input() isFromWorkoutExe: boolean = false;
  @Input() alternativeExercise?: any;
  popOverDetails: any = {
    isOpen: false,
    name: null
  };
  popOverMuscleDetails: any = {
    isOpen: false,
    name: null
  };
  environment = environment.baseURL;

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.exercise = data.exercise;
    this.equips = data.equips;
  }

  ngOnInit() {
    console.debug(this.exercise)
    console.debug(this.equips);
    console.debug(this.alternativeExercise);
    setTimeout(() => {
      const resizeImg = new ImageResize({
      width: 857,
      height: 906,
      element : '#sagoma'
    });
    }, 500);


    let ref = this;
    setTimeout(function () {
      ref.muscle();
    }, 1500)
    setTimeout(() => {
      localStorage.getItem('tourExerciseDetailShowed') ? null : this.startTour();
    }, 850);
  }

  closeModal() {
    this.dialogRef.close();
  }

  equipNameConvert(equip) {
    return equip.replace(/[^A-Z0-9]+/ig, "_");
  }

  equipFullName(name) {
    this.popOverDetails.isOpen = false;
    setTimeout(() => {
      this.popOverDetails = {
        isOpen: true,
        name: name
      }
    }, 300);
  }

  muscleFullName(name) {
    this.popOverMuscleDetails.isOpen = false;
    setTimeout(() => {
      this.popOverMuscleDetails = {
        isOpen: true,
        name: name
      }
    }, 300);
  }

  muscle(){
    $('.map').maphilight({
      fade: false,
      fillColor: "db3687",
      fillOpacity: '1',
      strokeColor: 'db3687'
  });
    let muscleGroup = this.exercise.muscleGroups;
    for (var k in muscleGroup) {
      $('.'+muscleGroup[k]).mouseover();
    }
  }

  swapExercise(){
    this.dialogRef.close('swap')
  }

  startTour(): void {
    localStorage.setItem('tourExerciseDetailShowed', 'true');

    let steps: any = [
      { element: '.img-exercise', popover: { title: this.translate.instant('TUTORIALS.exercise-detail.watchVideoTitle'), description: this.translate.instant('TUTORIALS.exercise-detail.watchVideoDescription'), side: 'bottom' } },
      { element: '.all-exercise-info', popover: { title: this.translate.instant('TUTORIALS.exercise-detail.checkLevelTitle'), description: this.translate.instant('TUTORIALS.exercise-detail.checkLevelDescription') } },
      { element: '.muscle-g', popover: { title: this.translate.instant('TUTORIALS.exercise-detail.viewMusclesTitle'), description: this.translate.instant('TUTORIALS.exercise-detail.viewMusclesDescription'), side: 'bottom' } },
      { element: '.exercise-description', popover: { title: this.translate.instant('TUTORIALS.exercise-detail.readDescriptionTitle'), description: this.translate.instant('TUTORIALS.exercise-detail.readDescriptionDescription') } },
    ];
    if(this.isFromWorkoutExe){
      steps.splice(0, 2);
    }

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps
    });

    driverObj.drive();
  }

}
